import routes from 'actions/routes';
import {
    generateReadActionCreator,
    generateUpdateActionCreator,
} from 'actions/crudActionCreators';
import ACTION_NAMES from 'actions/ACTION_NAMES';

export default {
    readArchivedReports: generateReadActionCreator(`${routes.API_RECORDS}/archive`, ACTION_NAMES.ARCHIVED_RECORDS),
    archiveRecords: generateUpdateActionCreator(`${routes.API_RECORDS}/archive`, ACTION_NAMES.ARCHIVE, () => { }, () => { }),
    unArchiveRecords: generateUpdateActionCreator(`${routes.API_RECORDS}/unarchive`, ACTION_NAMES.UNARCHIVE, () => { }, () => { }),
    getArchiveUsers: generateReadActionCreator(`${routes.API_RECORDS}/archive/users`, ACTION_NAMES.ARCHIVE_USERS, () => { }, () => { }),
};
